import ScheduledSettingsController from './scheduled-settings.controller';
import { ScheduledSettingsProps } from './scheduled-settings.model';

export const WorkflowSettings = (props: ScheduledSettingsProps) => {
  return <ScheduledSettingsController {...props} />;
};
